import User from "../../../client/models/user"

export default class Menu {

    readonly kbn: string 
    readonly link: string 
    readonly name: string 
    readonly viewName: string 
    readonly visibility: string 
    readonly subMenuKey: string 
    readonly pageCustomId: string 
    readonly url: string 
    readonly isTargetBlank: boolean
    public menuItems: Menu[] = []

    constructor(data: { [key: string]: any }) {
        this.kbn = data.kbn
        this.link = data.link
        this.name = data.name
        this.viewName = data.viewName
        this.visibility = data.visibility
        this.subMenuKey = data.subMenuKey
        this.pageCustomId = data.pageCustomId
        this.url = data.url
        this.isTargetBlank = data.isTargetBlank
        this.menuItems = (data.menuItems || []).map((item) => new Menu(item))
    }
}
